{
  "page_helseregistre_desc": "Her får du oversikt over utvalgte helseregistre og informasjon om hvordan du kan få innsyn i opplysninger som kan være registrert om deg.",
  "expandButtonCloseText": "Vis mindre",
  "page_helseregistre_title": "Helseregistre",
  "registeroppforing_InfoMessage_Title": "Savner du et register?",
  "registeroppforing_InfoMessage_Body": "Det er mulig at oversikten ikke er komplett. Hvis du savner et register, kan du laste siden på nytt for å hente en oppdatert liste.",
  "conversationSubmitErrorMessage": "Sjekk at alt er riktig utfylt",
  "conversationSubmitMessageRequired": "Du må skrive inn hva det gjelder",
  "conversationSubmitProceedButtonText": "Send",
  "conversationSubmitCancelButtonText": "Avbryt",
  "conversationSubmitConfirmationHeading": "Meldingen er sendt",
  "conversationSubmitConfirmationDescriptionTitle": "Takk for din henvendelse.",
  "conversationSubmitConfirmationDescriptionBody": "<p>Du finner sendte og mottatte meldinger i innboksen.</p>",
  "conversationSubmitConfirmationButtonText": "OK",
  "conversationSubmitDiscardCancelButtonText": "Forkast endringer",
  "conversationSubmitDiscardDescription": "Hvis du forlater siden, vil du miste alle endringer du har gjort.",
  "conversationSubmitDiscardHeading": "Det finnes endringer som ikke er lagret",
  "conversationSubmitDiscardProceedButtonText": "Fortsett redigering",
  "innsynslenkePrefixLoggInn": "Logg inn for å se {0}",
  "bestillInnsynLightBoxDialog4": "",
  "bestillingPaaVentMessageBody": "Rapporten(e) vil inneholde opplysninger som er registrert frem til det tidspunktet rapporten lages.\n<br><br>\nDet tar vanligvis kort tid fra du bestiller til du får svar, og du kan sjekke status underveis her. I enkelte tilfeller kan det ta lengre tid, og du kan bestille på nytt ved behov.",
  "innsynslenke_label": "Se innhold i registeret",
  "innsynslenke_logg_inn_label": "Logg inn for å se innhold",
  "innsynslenke_logg_inn_async_label": "Logg inn for å se innhold",
  "helseregistre_navigatebacklink_title": "Helseregistre",
  "melde_feil_over_max_length_error": "Du har skrevet for mange tegn. Gjør teksten kortere.",
  "melding_label": "Din melding",
  "message_label_info": "Maksimum 400 tegn.",
  "message_henvendelse_info": "Henvendelsen vil bli journalført.",
  "retry_knapp": "Last inn registrene på nytt",
  "messageSubmitHeading": "Skriv melding til",
  "databehandlingsansvarlig": "er dataansvarlig.",
  "expandButtonText": "Les mer",
  "informasjonLenkePrefix": "Les mer om",
  "innsynsrettLenkePrefix": "Les mer om innsynsrett i",
  "innsynUtleveringLink": "Be om innsyn i hvem som har fått utlevert opplysninger om meg",
  "innsynUtleveringSubject": "Innsyn i hvem som har fått utlevert opplysninger om meg",
  "meldeFeilInfo": "Dersom du har spørsmål om opplysninger i registeret, eller om du mener opplysninger registrert om deg er feil, kan du skrive om det her.",
  "meldeFeilLink": "Still spørsmål eller meld fra om feil i opplysninger som er registrert om meg",
  "messageSubmitDescription": "Din forespørsel vil normalt bli besvart i løpet av 30 dager.",
  "filterRegistreUnit": "registre",
  "filterRegistreAv": "av",
  "filterIngenRegistre": "Ingen registre",
  "registerSistOppdatert": "Sist oppdatert:",
  "filterDigitaltInnsyn": "Vis kun registre som tilbyr innsyn på Helsenorge",
  "loginButtonText": "Logg inn for å få komplett helseregisteroversikt",
  "communicateWithRegisterButtonText": "Logg inn for å bestille innsynsrapport",
  "clientOperation_GetRegisterInnsyn_Error_Title": "Teknisk feil",
  "clientOperation_GetRegisterInnsyn_Error_Body": "Det har skjedd en teknisk feil ved uthenting av innsynsrapporten. Prøv igjen senere.",
  "clientOperation_GetRegisterInnsyn_not_available": "Denne tjenesten er ikke tilgjengelig",
  "pdfCompatibilityTitle": "Last ned dokumentet?",
  "pdfCompatibilityBody": "Dette dokumentet kan ikke åpnes i din nettleser. Vil du laste det ned og prøve å åpne det med en annen applikasjon?",
  "pdfCompatibilityCancel": "Avbryt",
  "pdfCompatibilityConfirm": "Last ned",
  "pdfCompatibilityBodyPreview": "Vil du laste ned dokumentet og åpne det selv i et annet program, eller vil du se en forhåndsvisning?",
  "pdfCompatibilityPreview": "Se forhåndsvisning",
  "pdfCompatibilityClose": "Lukk",
  "pdfDownloadComplete": "Dokument ble lastet ned til din enhet",
  "clientOperation_SendRegisterInnsyn_Error_Title": "Teknisk feil",
  "clientOperation_SendRegisterInnsyn_Error_Body": "Det oppstod en feil, og en eller flere rapporter ble ikke bestilt. Prøv igjen senere.",
  "default_ErrorMessage_Body": "Prøv igjen senere.",
  "default_ErrorMessage_Title": "Det har skjedd en teknisk feil",
  "bestillInnsynBestill": "Bestill",
  "bestillInnsynKvitteringOk": "OK",
  "innsynKanIkkeLastes": "Innsyn kan ikke lastes",
  "bestillInnsynLightBoxHeader": "Velg innsynsrapport",
  "bestillInnsynLightBoxDialog1": "Innsyn i opplysninger som er registrert om meg",
  "bestillInnsynLightBoxDialog2": "Innsyn i hvem som har fått utlevert opplysninger om meg",
  "bestillInnsynLightBoxDialog3": "Innsyn i hvem som har sett dine opplysninger",
  "innsyn_footer_content": "Innhold er levert av",
  "etter_ingress_tekst": "Hvis rapporten inneholder noe du mener er feil eller informasjon du ønsker å få slettet, kan du kontakte ansvarlig for registeret.",
  "innsynIRegister": "Innsyn i",
  "innsyn_ingress": "Her ser du hvilke opplysninger som er registrert om deg i {0}, til og med datoen som vises øverst på siden. Ønsker du å se hvilke opplysninger som har blitt registrert etter den datoen, må du bestille en ny innsynsrapport.",
  "bestillInnsynsRapport": "Bestill innsynsrapport",
  "bestillingPaaVentMessage": "Du har bestilt følgende innsynsrapport(er) og venter fremdeles på svar fra registeret:",
  "bestillInnsynKvitteringsTekst": "Du får et varsel på Helsenorge når rapporten er klar. Rapporten blir lagret automatisk på Helsenorge som et dokument. Du kan også sjekke status selv når som helst og bestille på nytt ved behov.",
  "bestillInnsynKvitteringsHeader": "Innsynsrapport er bestilt",
  "varselmeny_RegisterInnsyn_SvarUtenData_tekst": "Du har bestilt innsyn i {0}, men registeret svarer at det ikke har registrert noen opplysninger om deg. Ta eventuelt direkte kontakt med registeret.",
  "varselmeny_RegisterInnsyn_SvarUtenData_emne": "Tomt registerinnsyn",
  "register_tidligeresvar": "Innsynsrapporter mottatt fra dette registeret ligger lagret i <a href=\"/dokumenter/?InnholdTyper=8&KontekstTyper=2\">Dokumenter</a>.",
  "meldeFeil_meldingsendt": "Melding sendt",
  "varselmeny_InnsynsrapportManglendeApprec_Emne": "Bestilling av rapport fra {0} den {1} feilet. Vennligst prøv igjen.",
  "clientOperation_GetRegisteroppforing_Warning_Title": "Visningen kan være ufullstendig",
  "clientOperation_GetRegisteroppforing_Warning_Body": "Noen systemer svarer for øyeblikket ikke. Prøv igjen senere.",
  "varselmeny_RegisterInnsyn_Svar_emne": "Innsyn i helseregister",
  "varselmeny_RegisterInnsyn_Svar_tekst": "Du har mottatt en innsynsrapport fra {0}",
  "bestillInnsyn_Error_Body": "Du har bestilt innsynsrapport, men noe har gått galt. Bestill rapport på nytt hvis du fortsatt ønsker å motta denne informasjonen.",
  "label_emneord": "Emneord"
}
